import * as React from "react";
import { useAccount, State } from "@grandvisionhq/auth";
import { useFeatureToggles } from "@grandvisionhq/state";
import { ClickAndReserveContext } from "./ClickAndReserveContext.js";
const ClickAndReserveProvider = ({
  children
}) => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [selectedStore, setSelectedStore] = React.useState();
  const [searchLocation, setSearchLocation] = React.useState();
  const [user, setUser] = React.useState();
  const [reservationNumber, setReservationNumber] = React.useState();
  const [preferredChannelOfCommunication, setPreferredChannelOfCommunication] = React.useState();
  const customerDetailsFormState = React.useRef();
  const onChangeCustomerDetails = React.useCallback((state) => {
    customerDetailsFormState.current = state;
  }, []);
  const customerDetailsPrefilled = React.useRef(false);
  const { isMyAccountEnabled } = useFeatureToggles();
  const authState = useAccount();
  const isAuthLoading = isMyAccountEnabled ? authState === "UNKNOWN" : false;
  const isLoggedIn = isMyAccountEnabled && isAuthLoading ? void 0 : authState === State.AuthState.LoggedIn;
  return /* @__PURE__ */ React.createElement(
    ClickAndReserveContext.Provider,
    {
      value: {
        activeStep,
        setActiveStep,
        selectedStore,
        setSelectedStore,
        searchLocation,
        setSearchLocation,
        user,
        setUser,
        customerDetailsFormState,
        onChangeCustomerDetails,
        customerDetailsPrefilled,
        isAuthLoading,
        isLoggedIn,
        reservationNumber,
        setReservationNumber,
        preferredChannelOfCommunication,
        setPreferredChannelOfCommunication
      }
    },
    children
  );
};
export {
  ClickAndReserveProvider
};
//# sourceMappingURL=ClickAndReserveProvider.js.map
